import * as $ from "jquery";

export class KnockoutHelper {

    public static arrayFirstIndexOf(array: any[], predicate: any, predicateOwner?: any): number {
        for (let i = 0, j = array.length; i < j; i++) {
            if (predicate.call(predicateOwner, array[i])) {
                return i;
            }
        }
        return -1;
    }

    public static initDataTablesWithExcelButton(tableId: string, options: any): void {
        let table = $("#" + tableId).DataTable(options);

        table.buttons().container().appendTo("#" + tableId + "_wrapper .col-md-6:eq(0)");
    }
}